<nav class="navbar navbar-expand-lg navbar-light bg-light elevation" >
  <div class="navbar-brand logo" >
      <a id="navegacao-links" routerLink="">
<img class="logo_img" src="../../../../assets/images/serasajud3.png" />
  </a>
  </div>
  <div class="collapse navbar-collapse navbar-header" id="navbarSupportedContent">
    <ul *ngIf="auth.isUserLoggedIn()" class="navbar-nav mr-auto">
      <li class="nav-item">
        <button mat-button routerLink="/ordem" >Página Inicial</button>
      </li>
      <li class="nav-item">
          <button mat-button routerLink="/listar-ordem" >Ordens Cadastradas</button>
      </li>
    </ul>
    <li class="nav-item" [hidden]="!auth.isUserLoggedIn()">
      <seds-timer #timer [colorMode]="colorDark" (finishedTime)="timeOver($event)"></seds-timer>
    </li>

    <ul *ngIf="!auth.isUserLoggedIn()" class="navbar-nav mr-auto">
      <li class="nav-item">
        <button mat-button routerLink="/login" >Entrar</button>
      </li>
    </ul>
    <div class="form-inline my-2 my-lg-0" *ngIf="auth.isUserLoggedIn()">
      <ul class="float-right text-right dado"  >
          <li>
          <button class="usuario-menu" mat-button [matMenuTriggerFor]="usuarios">
            {{usuario?.fullName}}
          </button>
          <mat-menu #usuarios="matMenu">
            <!--
            <div mat-menu-item >{{usuario.email.email}}</div>
          <button mat-menu-item >Perfil</button>
            <button mat-menu-item >Acessos</button>
            -->
            <button mat-menu-item routerLink="/logout" >Sair</button>
          </mat-menu>
          </li>
          <li>
            <p *ngIf="cargo == 'D'" class="text-right perfil">Dirigente</p>
            <p *ngIf="cargo == 'M'" class="text-right perfil">Magistrado</p>
            <p *ngIf="cargo == 'J'" class="text-right perfil">Juiz</p>
          </li>
      </ul>
      <ul class="icone-usuario">
        <li>
            <img id="u70_img" class="img " src="../../../../assets/images/ordem/u70.png">
        </li>
      </ul>
    </div>
  </div>
</nav>


